<template>
  <div class="container mt-4">
    <!-- Breadcrumb -->
    <b-breadcrumb class="m-3">
      <b-breadcrumb-item href="/"> <i class="fa fa-home" aria-hidden="true"></i> Home</b-breadcrumb-item>
      <b-breadcrumb-item href="/residentslist-prov"> Residents</b-breadcrumb-item>
      <b-breadcrumb-item active> {{ getBread("-prov") }}</b-breadcrumb-item>
    </b-breadcrumb>
    <div class="customCard">
      <h1 style="font-size: 2rem; text-align: center; padding-bottom: 1rem">
        List of Providers {{ fullName }}
      </h1>
    </div>

    <div v-if="loading" class="text-center">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <div v-else-if="error" class="text-center text-danger">
      <p>Error loading data.</p>
    </div>
    <div v-else>
      <div v-if="getUserRole('admins')">
      <button class="btn btn-primary mb-4" @click="showAddModal = true">
        Add Provider
      </button>
      </div>
      <table class="table table-striped">
        <thead>
          <tr>
            <th scope="col">Provider Name</th>
            <th scope="col">Provider Type</th>
            <th scope="col">Phone</th>
            <th scope="col">Email</th>
            <th scope="col">Address</th>
            <th scope="col" v-if="getUserRole('admins') || getUserRole('editors')">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="provider in paginatedProviders" :key="provider.id">
            <td> <a href="#" @click.prevent="viewEntry(provider)">
              {{ provider.attributes.providername }}
            </a>
            </td>
            <td>{{ getProviderTypeText(provider.attributes.providertype) }}</td>
            <td>{{ provider.attributes.phone }}</td>
            <td>{{ provider.attributes.email }}</td>
            <td>{{ provider.attributes.address }}</td>
            <td v-if="getUserRole('admins') || getUserRole('editors')"><a href="#" @click.prevent="editEntry(provider)">Edit</a> </td>
          </tr>
        </tbody>
      </table>
      <div class="d-flex justify-content-between align-items-center">
        <p>
          Showing {{ startIndex + 1 }} to {{ endIndex }} of
          {{ result.residentproviders.data.length }} entries
        </p>
        <ul class="pagination">
          <li class="page-item" :class="{ disabled: currentPage === 1 }">
            <a
              class="page-link"
              href="#"
              @click.prevent="changePage(currentPage - 1)"
              >Prev</a
            >
          </li>
          <li
            class="page-item"
            v-for="page in totalPages"
            :key="page"
            :class="{ active: currentPage === page }"
          >
            <a class="page-link" href="#" @click.prevent="changePage(page)">{{
              page
            }}</a>
          </li>
          <li
            class="page-item"
            :class="{ disabled: currentPage === totalPages }"
          >
            <a
              class="page-link"
              href="#"
              @click.prevent="changePage(currentPage + 1)"
              >Next</a
            >
          </li>
        </ul>
      </div>
    </div>

    <!-- Edit Modal -->
    <b-modal size="xl" v-model="showEditModal" hide-footer :title="'Edit Provider '+fullName">
      <form v-if="currentProvider" @submit.prevent="updateEntry">
        <div class="row">
          <div class="col-md-4">
            <div class="mb-3">
              <label for="providername" class="form-label">Provider Name</label>
              <input
                type="text"
                class="form-control"
                id="providername"
                v-model="currentProvider.attributes.providername"
              />
            </div>           
            <div class="mb-3">
              <label for="providertype" class="form-label">Provider Type</label>
              <select
                class="form-select"
                id="providertype"
                v-model="currentProvider.attributes.providertype"                
              >
                <option
                  v-for="option in providerTypes"
                  :key="option.value"
                  :value="option.value"
                >
                  {{ option.text }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-md-4">
            <div class="mb-3">
              <label for="phone" class="form-label">Phone</label>
              <input
                type="text"
                class="form-control"
                id="phone"
                v-model="currentProvider.attributes.phone"                
              />
            </div>
            <div class="mb-3">
              <label for="email" class="form-label">Email</label>
              <input
                type="text"
                class="form-control"
                id="email"
                v-model="currentProvider.attributes.email"                
              />
            </div>  
          </div>
          <div class="col-md-4">
            <div class="mb-3">
              <label for="address" class="form-label">Address</label>
              <input
                type="text"
                class="form-control"
                id="address"
                v-model="currentProvider.attributes.address"                
              />
            </div>  
          </div>
          <div class="d-grid">
            <button type="submit" class="btn btn-primary">Save changes</button>
          </div>
        </div>
      </form>
      <div v-if="updateError" class="alert alert-danger mt-3">
        {{ updateError }}
      </div>
    </b-modal>

     <!-- View Modal -->
     <b-modal size="xl" v-model="showViewModal" hide-footer :title="'View Provider '+fullName">
      <form v-if="currentProvider">
        <div class="row">
          <div class="col-md-4">
            <div class="mb-3 d-flex flex-row align-items-center">
              <strong class="me-2">Provider Name:</strong>
              <span>{{ currentProvider.attributes.providername }} </span>
            </div>           
            <div class="mb-3 d-flex flex-row align-items-center">
              <strong class="me-2">Provider Type:</strong>
              <span>{{ getProviderTypeText(currentProvider.attributes.providertype) }}</span>               
            </div>
          </div>
          <div class="col-md-4">
            <div class="mb-3 d-flex flex-row align-items-center">
              <strong class="me-2">Phone.:</strong>
              <span>{{ currentProvider.attributes.phone }} </span>                
            </div>  <div class="mb-3 d-flex flex-row align-items-center">
              <strong class="me-2">Email:</strong>
              <span>{{ currentProvider.attributes.email }}</span>              
            </div>   
          </div>
          <div class="col-md-4">
            <div class="mb-3 d-flex flex-row align-items-center">
              <strong class="me-2">Address:</strong>
              <span>{{ currentProvider.attributes.address }}</span>              
            </div>                       
          </div>         
        </div>
      </form>
    </b-modal>

    <!-- Add Modal -->
    <b-modal size="xl" v-model="showAddModal" hide-footer :title="'Add Provider '+fullName">
      <form @submit.prevent="addEntry">
        <div class="row">
          <div class="col-md-4">
            <div class="mb-3">
              <label for="providername" class="form-label">Provider Name</label>
              <input
                type="text"
                class="form-control"
                id="providername"
                v-model="newProvider.providername"
                required
              />
            </div>           
            <div class="mb-3">
              <label for="providertype" class="form-label">Provider Type</label>
              <select
                class="form-select"
                id="providertype"
                v-model="newProvider.providertype"
                required
              >
                <option
                  v-for="option in providerTypes"
                  :key="option.value"
                  :value="option.value"
                >
                  {{ option.text }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-md-4">
            <div class="mb-3">
              <label for="phone" class="form-label">Phone</label>
              <input
                type="text"
                class="form-control"
                id="phone"
                v-model="newProvider.phone"
                required
              />
            </div>            
            <div class="mb-3">
              <label for="email" class="form-label">Email</label>
              <input
                type="text"
                class="form-control"
                id="email"
                v-model="newProvider.email"
              />
            </div>            
          </div>
          <div class="col-md-4">
            <div class="mb-3">
              <label for="address" class="form-label">Address</label>
              <input
                type="text"
                class="form-control"
                id="address"
                v-model="newProvider.address"
              />
            </div>            
          </div>
          <div class="d-grid">
            <button type="submit" class="btn btn-primary">Add provider</button>
          </div>
        </div>
      </form>
      <div v-if="addError" class="alert alert-danger mt-3">
        {{ addError }}
      </div>
    </b-modal>
  </div>
</template>
  
  <script>
import { useQuery, useMutation } from "@vue/apollo-composable";
import { GET_PROVIDERS_BY_RESIDENT, UPDATE_PROVIDER, CREATE_PROVIDER, GET_FULLNAME_BY_ID } from "../hooks/queries";
import { ref, computed } from "vue";
import { providerTypes, usStates, getBread, getUserRole } from "../components/values";
import { useRoute } from 'vue-router'; // Import useRoute from Vue Router  


export default {
  name: "ResProvider",
  
  setup() {
    const route = useRoute(); // Use useRoute to get the current route
    const residentId = route.params.id; // Access the route parameter directly
    const { result:result, loading:loading, error:error, refetch:refetch } = useQuery(GET_PROVIDERS_BY_RESIDENT,{residentId: residentId});
    const { mutate: updateResidentprovider } = useMutation(UPDATE_PROVIDER);
    const { mutate: createProvider } = useMutation(CREATE_PROVIDER);
    const currentProvider = ref(null);
    const updateError = ref(null);
    const addError = ref(null);
    const showEditModal = ref(false);
    const showAddModal = ref(false);
    const showViewModal = ref(false);

    const {result:resultfullname, loading:loadingfullname, error:errorfullname, refetch:refetchfullname } = useQuery(GET_FULLNAME_BY_ID, {
      id: residentId,
    });

      // Watch the result and compute the full name only when the data is available
      const fullName = computed(() => {
      const data = resultfullname.value?.resident?.data;
      if (data) {
        return `(${data.attributes.firstname} ${data.attributes.lastname})`;
      }
      return null;
    });


    const newProvider = ref({
      providername: "",
      providertype: "",     
      phone: "",
      email: "",
      publishedAt: new Date().toISOString(),
    });

    const addEntry = async () => {
      addError.value = null;
      try {
        await createProvider({
          data: {
            resident: residentId, // Include the residentId in the input data
            providername: newProvider.value.providername,            
            providertype: newProvider.value.providertype,            
            phone: newProvider.value.phone,
            email: newProvider.value.email,
            address: newProvider.value.address,
            publishedAt: new Date().toISOString(),
          },
        });
        showAddModal.value = false;
        newProvider.value = {
          providername: "",
          providertype: "",
          phone: "",
          email: "",
          address: "",
        };
        await refetch(); // Refetch the list of providers after adding a new 
        await refetchfullname();
      } catch (e) {
        //console.error("Error adding entry:", e);
        addError.value = `Failed to add provider. Please try again.}`;
      }
    };

    const formatDate = (date) => {
      const options = { year: "numeric", month: "long", day: "numeric" };
      return new Date(date).toLocaleDateString(undefined, options);
    };

    const editEntry = (provider) => {
      //currentProvider.value = { ...provider }; // Copy provider to avoid directly modifying the original data
      currentProvider.value = JSON.parse(JSON.stringify(provider)); // Create a deep copy of the docuement object
      showEditModal.value = true;
    };

    const updateEntry = async () => {
      updateError.value = null; // Reset the error message
      try {
        await updateResidentprovider({
          id: currentProvider.value.id,
          data: {
            providername: currentProvider.value.attributes.providername,            
            providertype: currentProvider.value.attributes.providertype,            
            phone: currentProvider.value.attributes.phone,
            email: currentProvider.value.attributes.email,
            address: currentProvider.value.attributes.address,
          },
        });
        //console.log("Updated entry:", currentProvider.value);
        showEditModal.value = false;
      } catch (error) {
        //console.error("Error updating entry:", error);
        updateError.value = "Failed to update Provider. Please try again.";
      }
    };

    const viewEntry = (provider) => {
      currentProvider.value = JSON.parse(JSON.stringify(provider)); // Create a deep copy of the provider object
      showViewModal.value = true;
    };

    const getProviderTypeText = (value) => {
      const option = providerTypes.find((option) => option.value === value);
      return option ? option.text : "";
    };

    const getStates = (value) => {
      const option = usStates.find((option) => option.value === value);
      return option ? option.text : "";
    };

    return {
      result,
      loading,
      error,
      formatDate,
      showEditModal,
      showAddModal,
      showViewModal,
      currentProvider,
      newProvider,
      editEntry,
      viewEntry,
      updateEntry,
      addEntry,
      updateError,
      addError,
      providerTypes,
      getProviderTypeText,
      getStates,
      usStates,
      getBread,
      getUserRole,
      residentId,
      errorfullname,
      loadingfullname,
      fullName,   
    };
  },
  data() {
    return {
      currentPage: 1,
      itemsPerPage: 10,
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(
        this.result.residentproviders.data.length / this.itemsPerPage
      );
    },
    paginatedProviders() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      return this.result.residentproviders.data.slice(
        start,
        start + this.itemsPerPage
      );
    },
    startIndex() {
      return (this.currentPage - 1) * this.itemsPerPage;
    },
    endIndex() {
      return Math.min(
        this.startIndex + this.itemsPerPage,
        this.result.residentproviders.data.length
      );
    },
    
  },
  methods: {
    changePage(page) {
      if (page > 0 && page <= this.totalPages) {
        this.currentPage = page;
      }
    },
  },
};
</script>
  
  <style>
.container {
  max-width: 80%;
}

.d-grid {
  background-color: #e8e8e8;
  margin-bottom: 20px;
}

.text-center {
  text-align: center;
}
.spinner-border {
  margin-top: 20px;
}
.pagination {
  margin: 0;
}
</style>
  
